import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { useConfig } from 'builder/hooks/useConfig'
import { selectors, ResumeFieldSuggest } from 'builder/modules/resumeEditor'
import useImproveResumePanel from '../ImproveResumePanel/hooks/useImproveResumePanel'
import { SuggestionBadge } from './SuggestionBadge'

type Props = {
  fieldId: string
  sectionId: string
}

export const InputSuggestionBadge = ({ fieldId, sectionId }: Props) => {
  const config = useConfig()
  const { suggestions } = useTypedSelector(selectors.scoreSuggestions)
  const { getSuggestionScore } = useImproveResumePanel()

  const fieldSuggestion = suggestions.find(
    (suggestion: ResumeFieldSuggest) =>
      suggestion.type === 'simpleField' &&
      suggestion.fieldId === fieldId &&
      suggestion.sectionId === sectionId,
  )

  if (!fieldSuggestion || !config?.features.isNewBuilderEnabled) {
    return null
  }

  const score = getSuggestionScore(fieldSuggestion)

  return <SuggestionBadge suggestion={fieldSuggestion} score={score} />
}
